import { useTranslations } from '@/hooks/useTranslations'

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { UserDropdown } from '@/constants/user'
import MoreVertIcon from '~icons/dl/more_vert.jsx'
import { RoleStatus } from '@/constants/role'
import { useProfileData } from '@/hooks/useProfile'

type ActionDropdownProps = {
  isDefault?: boolean
  status: RoleStatus
  onClickDropdownItem: (eventName: UserDropdown) => void
}

export const ActionDropdown = ({ isDefault, status, onClickDropdownItem }: ActionDropdownProps) => {
  const t = useTranslations('common')

  const { profile } = useProfileData()

  if (isDefault && profile?.type !== 'admin') {
    return null
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className="flex w-7 h-7 justify-center items-center">
            <MoreVertIcon />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          {/* <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.VIEW)}
          >
            {t('dropdown.view')}
          </DropdownMenuItem> */}
          {(isDefault ? profile?.type === 'admin' : true) && <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.EDIT)}
          >
            {t('dropdown.edit')}
          </DropdownMenuItem>}
          {!isDefault && <DropdownMenuItem
            className="flex gap-2"
            onClick={() => onClickDropdownItem(UserDropdown.DELETE)}
          >
            {t('dropdown.delete')}
          </DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
